/**
 * The study URLs, mirrored from `libs/poker-utils/src/lib/variants/study-dispatch.ts`
 * — that module is the source of truth; change it there first.
 *
 * Copied rather than imported because this lib is the only package BOTH
 * `apps/gto-wizard-web` and `apps/admin-web` depend on, and admin-web does not
 * depend on `@gto/poker-utils`. The copy is not free-floating: gto-wizard-web
 * depends on both packages, and its announcements suite asserts the rewrite lands
 * on poker-utils' own `STUDY_PATH`, so drift fails a test rather than silently
 * unmatching production rows.
 */
const STUDY_PATH = '/solutions'
const LEGACY_STUDY_PATH = `${STUDY_PATH}/v2`

/**
 * Rewrites a `/solutions/v2…` prefix onto the collapsed study URL.
 *
 * Announcement prefix lists are PRODUCTION DB rows, authored by marketing against
 * the URLs that existed when the row was written. FE-912 removed the `/v2`
 * segment — both study arms answer at `/solutions` now, and `/solutions/v2/*`
 * only ever appears as a redirect that is gone by the time a pathname reaches the
 * customer matcher. The rows cannot be migrated from the client, so an unrewritten
 * one would silently stop matching and the announcement would vanish from the
 * study. A row authored against the new URL passes through untouched.
 *
 * Apply this to INCLUDE prefixes ONLY, never to `route_exclude_prefixes`. The
 * asymmetry is deliberate: rewriting an include RESTORES the reach the row was
 * authored for, while rewriting an exclude WIDENS it onto the legacy arm — a live
 * A/B arm — hiding the announcement somewhere it used to appear.
 *
 * Matched on the WHOLE segment: `/solutions/v2beta` is not a legacy study URL, and
 * a bare `startsWith` would rewrite it to the nonexistent `/solutionsbeta`.
 */
export function collapseLegacyStudyPrefix(prefix: string): string {
  const isLegacyStudyPrefix =
    prefix === LEGACY_STUDY_PATH || prefix.startsWith(`${LEGACY_STUDY_PATH}/`)

  return isLegacyStudyPrefix ? `${STUDY_PATH}${prefix.slice(LEGACY_STUDY_PATH.length)}` : prefix
}
